import { render, staticRenderFns } from "./add-to-cart-standalone.vue?vue&type=template&id=2b313d04"
import script from "./add-to-cart-standalone.vue?vue&type=script&lang=js"
export * from "./add-to-cart-standalone.vue?vue&type=script&lang=js"
import style0 from "./add-to-cart-standalone.vue?vue&type=style&index=0&id=2b313d04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports